var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4694 14.3211C16.8204 13.6672 15.2487 12.7131 14.4861 12.3286C13.4931 11.8284 13.4114 11.7875 12.6308 12.3674C12.1102 12.7544 11.764 13.1001 11.1547 12.9701C10.5454 12.8402 9.22132 12.1075 8.06194 10.9519C6.90257 9.79623 6.12733 8.43384 5.99697 7.82661C5.8666 7.21938 6.21805 6.87735 6.60138 6.35552C7.14163 5.61997 7.10077 5.49738 6.63898 4.5044C6.27894 3.73207 5.29692 2.17517 4.64061 1.52952C3.93853 0.836068 3.93853 0.958658 3.48614 1.14663C3.11784 1.30158 2.7645 1.48993 2.43056 1.70932C1.7767 2.1437 1.4138 2.50453 1.16002 3.04679C0.906241 3.58905 0.792224 4.86032 2.10281 7.24103C3.41339 9.62175 4.33289 10.8391 6.23603 12.7368C8.13918 14.6345 9.60261 15.6549 11.742 16.8546C14.3885 18.3367 15.4036 18.0478 15.9475 17.7945C16.4915 17.5411 16.8539 17.1815 17.2892 16.5277C17.5091 16.1943 17.6979 15.8414 17.8531 15.4734C18.0415 15.0227 18.1641 15.0227 17.4694 14.3211Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.d9c7053c7c62e002120f486c8e163489.svg";
export { ForwardRef as ReactComponent };